import { makeStyles } from '@mui/styles';
import { colors } from 'Constants/Colors';

export const useStyles = makeStyles({
  DatePickerDay: {
    marginRight: '.4rem !important',
    marginLeft: '.4rem !important',
  },
  DatePickerDaySelect: {
    backgroundColor: `${colors.GREEN_SHINING} !important`,
    marginRight: '.4rem !important',
    marginLeft: '.4rem !important',
  },
  CalendarPickerStyle: {
    width: '100% !important',
    marginLeft: '0 !important',
    marginBottom: '0 !important',
    '& .MuiCalendarPicker-viewTransitionContainer': {
      marginBottom: '0 !important',
      paddingBottom: '0 !important',
    },
    '& .MuiTypography-caption': {
      marginRight: '.4rem !important',
      marginLeft: '.4rem !important',
    },
  },
});

export default { useStyles };
